import React from 'react';
import { Box, Text, VStack, Image } from '@chakra-ui/react';

const QRCodeDisplay = ({ qrCode, secret }) => {
  return (
    <VStack spacing="2rem" align="center">
      <Box textAlign="center">
        <Text fontSize="18px" fontFamily="bold" color="#444" mb="1rem">
          Scan QR Code with Your Authenticator App
        </Text>
        <Text fontSize="14px" color="#666" lineHeight="1.6">
          Use Google Authenticator, Authy, or any TOTP authenticator app to scan
          this QR code.
        </Text>
      </Box>

      <Box
        bg="white"
        p="2rem"
        borderRadius="12px"
        boxShadow="0 4px 12px rgba(0,0,0,0.1)"
        border="2px solid #E0E0E0"
      >
        <Image src={qrCode} alt="MFA QR Code" w="250px" h="250px" />
      </Box>

      <Box textAlign="center" w="100%">
        <Text fontSize="12px" color="#999" mb="0.5rem">
          Or enter this code manually:
        </Text>
        <Box
          bg="#F5F5F5"
          p="1rem"
          borderRadius="6px"
          border="1px solid #E0E0E0"
        >
          <Text
            fontFamily="monospace"
            fontSize="16px"
            fontWeight="600"
            color="#444"
            letterSpacing="0.2rem"
          >
            {secret}
          </Text>
        </Box>
      </Box>
    </VStack>
  );
};

export { QRCodeDisplay };
